import axios from 'axios'

export default class ApiService {
	constructor(host, vue) {
		this.count = 0
		this.host = host
		this.params = {
			baseURL: host,
			withCredentials: true,
			timeout: 300000
		}
		this.httpAdapter = axios.create(this.params)
		this.vue = vue
	}

	callPost(method, data) {
		this.count = 0
		return this._handle(this._getHttpAdapter().post(method, data))
	}

	callPut(method, data) {
		this.count = 0
		return this._handle(this._getHttpAdapter().put(method, data))
	}

	callGet(method, params) {
		this.count = 0
		return this._handle(this._getHttpAdapter().get(method, {params: params}))
	}

	callGetFile(method, params) {
		this.count = 0
		return this._handle(this._getHttpAdapter().get(method, {params: params, responseType: "blob"}))
	}

	callDelete(method, params) {
		this.count = 0
		return this._handle(this._getHttpAdapter().delete(method, {params: params}))
	}

	keepAlive() {
		this._handle(this._getHttpAdapter().get('/keep_alive'))
		return this.count++
	}

	callAll(methods) {
		return axios.all(methods)
	}

	_handle(promise) {
		return promise.then(function (data) {
			return data.data
		}).catch(function (error) {
			let errorMessage = 'Omlouváme se, vyskytla se neznámá chyba.';
			let validationErrors = []
			let operatorInactive = false
			let redirectToLogin = false

			if (error.response) {
				const response = error.response
				if (typeof response.data.message === 'string') {
					validationErrors.push(response.data.message)
					errorMessage = response.data.message
				}else if (response.data.success === false && response.data.exception) {
					validationErrors.push(response.data.exception.message)
					errorMessage = 'Chyba požadavku. Zkontrolujte vyplněné údaje.'
				} if (response.data.success === false && response.data.message) {
					errorMessage = response.data.message.validation_errors ? response.data.message.validation_errors[0] :response.data.message
				} else if (response.status === 403) {
					redirectToLogin = true
					if (response.data.message === "Service suspended. Please, contact service provider.") {
						operatorInactive = true
						errorMessage = 'Služba byla pozastavena, obraťte se na jejího poskytovatele.'
					} else {
						errorMessage = 'Byl jste odhlášen.'
					}
				} else if (response.status === 404) {
					errorMessage = 'Požadavek nebo subjekt nebyl nalezen.'
				} else if (response.data.message && response.data.message.validation_errors) {
					if (typeof response.data.message.validation_errors === 'object') {
						validationErrors = Object.values(response.data.message.validation_errors);
						errorMessage = validationErrors[0];
					}
				}
			} else if (error.code && error.code === 'ECONNABORTED') {
					errorMessage = 'Vypršel časový limit pro požadavek. Akci opakujte později.'
			}

			throw {
				'error_message': errorMessage,
				'validation_errors': [...validationErrors],
				'operator_inactive': operatorInactive,
				'redirect_to_login': redirectToLogin,
			}
		}.bind(this))
	}

	_getHttpAdapter() {
		return this.httpAdapter
	}
}



// WEBPACK FOOTER //
// ./src/service/ApiService.js